import { render } from "./MineSweeper.vue?vue&type=template&id=1f801827&scoped=true"
import script from "./MineSweeper.vue?vue&type=script&lang=js"
export * from "./MineSweeper.vue?vue&type=script&lang=js"

import "./MineSweeper.vue?vue&type=style&index=0&id=1f801827&scoped=true&lang=css"

import exportComponent from "L:\\vuexiangmu\\oppt2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f801827"]])

export default __exports__